import { put, call, takeEvery, all } from 'redux-saga/effects'

import { FETCH_ALIASES, ADD_ALIAS, UPDATE_ALIAS, REMOVE_ALIAS } from '../actions/types'
import {
  fetchAliases,
  fetchAliasesSuccess,
  fetchAliasesFailure,
  addAliasSuccess,
  addAliasFailure,
  updateAliasSuccess,
  updateAliasFailure,
  removeAliasSuccess,
  removeAliasFailure,
} from '../actions/elasticAliasesActions'
import elasticService from '../services/elasticService'

function* handleFetchAliases(action) {
  try {
    const { accessToken } = action.payload

    // Fetch data from API
    const results = yield call(elasticService.fetchAliases, accessToken)

    yield put(fetchAliasesSuccess(results))
  } catch (err) {
    console.error(err, 'Error fetching elastic aliases')
    yield put(fetchAliasesFailure(err))
  }
}

function* handleAddAlias(action) {
  try {
    const { aliasName, indexName, accessToken } = action.payload

    // Fetch data from API
    yield call(elasticService.addAlias, accessToken, aliasName, indexName)

    // Broadcast success
    yield put(addAliasSuccess(action.payload))

    // Fetch new indices
    yield put(fetchAliases(accessToken))
  } catch (error) {
    console.error(error, 'Error adding elastic alias')
    yield put(addAliasFailure({ error, ...action.payload }))
  }
}

function* handleUpdateAlias(action) {
  try {
    const { aliasName, indexName, accessToken } = action.payload

    // Fetch data from API
    yield call(elasticService.updateAlias, accessToken, aliasName, indexName)

    // Broadcast success
    yield put(updateAliasSuccess(action.payload))

    // Fetch new indices
    yield put(fetchAliases(accessToken))
  } catch (error) {
    console.error(error, 'Error updating elastic alias')
    yield put(updateAliasFailure({ error, ...action.payload }))
  }
}

function* handleRemoveAlias(action) {
  try {
    const { aliasName, indexName, accessToken } = action.payload

    // Fetch data from API
    yield call(elasticService.removeAlias, accessToken, aliasName, indexName)

    // Broadcast success
    yield put(removeAliasSuccess(action.payload))

    // Fetch new indices
    yield put(fetchAliases(accessToken))
  } catch (error) {
    console.error(error, 'Error removing elastic alias')
    yield put(removeAliasFailure({ error, ...action.payload }))
  }
}

function* watchElasticAliasesSagas() {
  yield all([takeEvery(FETCH_ALIASES, handleFetchAliases), takeEvery(ADD_ALIAS, handleAddAlias), takeEvery(UPDATE_ALIAS, handleUpdateAlias), takeEvery(REMOVE_ALIAS, handleRemoveAlias)])
}

export default watchElasticAliasesSagas
